import React from 'react';
import { Link } from 'react-router-dom';
import { COPY } from '../contracts/copyMap';
import { ROUTES } from '../contracts/routes';
import LegalSections, { TITLES } from '../components/legal/LegalSections';
import HairlineDivider from '../components/oracle/HairlineDivider';
import PublicPageLayout from '../components/public/PublicPageLayout';

// Routed public legal pages (/legal/terms, /legal/privacy). Crawlable
// counterparts of the LegalModal — same content, same section renderer.
// `doc` is 'tos' | 'privacy'.
const PAGE_TITLES = {
  tos: COPY.PAGE_TITLE_TERMS,
  privacy: COPY.PAGE_TITLE_PRIVACY,
};

const CROSS_LINK = {
  tos: { label: COPY.ONBOARDING_TERMS_LINK_PRIVACY, to: ROUTES.LEGAL_PRIVACY },
  privacy: { label: COPY.ONBOARDING_TERMS_LINK_TOS, to: ROUTES.LEGAL_TERMS },
};

const Legal = ({ doc }) => (
  <PublicPageLayout
    title={PAGE_TITLES[doc]}
    eyebrow={COPY.LEGAL_PAGE_EYEBROW}
    headline={TITLES[doc]}
  >
    <p className="m-0 mb-8 font-display italic text-bone-dim">
      {COPY.LEGAL_LAST_UPDATED}
    </p>
    <LegalSections doc={doc} />
    <HairlineDivider />
    <Link
      to={CROSS_LINK[doc].to}
      className="font-display uppercase text-[12px] tracking-[0.2em] text-bone-dim no-underline transition-colors hover:text-bone"
    >
      {CROSS_LINK[doc].label}
    </Link>
  </PublicPageLayout>
);

export default Legal;
